import { bulletinboard as baseBulletinboard } from './baseApi/bulletinboard'

export type * from './baseApi/bulletinboard'

export {
  AlertType,
  BulletinBoardSearchStatus,
  BulletinBoardStatus,
} from './baseApi/bulletinboard'

export enum NoticeSortFieldEnum {
  title = 'Title',
  fromDate = 'FromDate',
  toDate = 'ToDate',
  createdBy = 'CreatedBy',
  withdrawn = 'WithdrawnDate',
  updatedDate = 'UpdatedDate',
  pinned = 'Pinned',
}

const invalidatesBulletinComments = (
  _result: unknown,
  error: unknown,
  arg: { bulletinId: string }
) => (error ? [] : [{ type: 'BulletinComments' as const, id: arg.bulletinId }])

export const bulletinboardApi = baseBulletinboard.enhanceEndpoints({
  addTagTypes: ['BulletinComments', 'BulletinAlerts', 'BulletinReadStatus'],
  endpoints: {
    getMaintenanceBulletinsByBulletinIdAlerts: {
      keepUnusedDataFor: 0,
      providesTags: (_result, _error, arg) => [
        { type: 'BulletinAlerts', id: arg.bulletinId },
      ],
    },
    postMaintenanceBulletinsByBulletinIdAlerts: {
      invalidatesTags: (_result, error, arg) =>
        error
          ? []
          : [
              { type: 'BulletinAlerts', id: arg.bulletinId },
              { type: 'BulletinReadStatus', id: arg.bulletinId },
            ],
    },
    getMaintenanceBulletinsByBulletinIdReadstatusDetails: {
      keepUnusedDataFor: 0,
      providesTags: (_result, _error, arg) => [
        { type: 'BulletinReadStatus', id: arg.bulletinId },
      ],
    },
    putMaintenanceBulletinsByBulletinId: {
      invalidatesTags: (_result, error, arg) =>
        error ? [] : [{ type: 'BulletinReadStatus', id: arg.bulletinId }],
    },
    getMaintenanceAlerts: {
      keepUnusedDataFor: 0,
    },
    getBulletinsByBulletinIdComments: {
      providesTags: (_result, _error, arg) => [
        { type: 'BulletinComments', id: arg.bulletinId },
      ],
    },
    postBulletinsByBulletinIdComments: {
      invalidatesTags: invalidatesBulletinComments,
    },
    putBulletinsByBulletinIdCommentsAndCommentId: {
      invalidatesTags: invalidatesBulletinComments,
    },
    deleteBulletinsByBulletinIdCommentsAndCommentId: {
      invalidatesTags: invalidatesBulletinComments,
    },
  },
})

export const {
  useGetBulletinsQuery,
  useGetBulletinsByBulletinIdQuery,
  usePutBulletinsByBulletinIdSetreadMutation,
  usePutBulletinsByBulletinIdSetunreadMutation,
  useGetBulletinsByBulletinIdAttachmentsAndAttachmentIdQuery,
  useGetBulletinsByBulletinIdEventQuery,
  usePostMaintenanceBulletinsListQuery,
  usePostMaintenanceBulletinsMutation,
  useGetMaintenanceBulletinsByBulletinIdQuery,
  usePutMaintenanceBulletinsByBulletinIdMutation,
  useDeleteMaintenanceBulletinsByBulletinIdMutation,
  usePostMaintenanceBulletinsByBulletinIdImageMutation,
  useDeleteMaintenanceBulletinsByBulletinIdImageMutation,
  useGetMaintenanceBulletinsByBulletinIdEventQuery,
  useGetMaintenanceBulletinsByBulletinIdReadstatusSummaryQuery,
  useGetMaintenanceBulletinsByBulletinIdReadstatusDetailsQuery,
  useGetMaintenanceBulletinsByBulletinIdAlertsQuery,
  usePostMaintenanceBulletinsByBulletinIdAlertsMutation,
  useDeleteMaintenanceBulletinsByBulletinIdAlertsMutation,
  usePostMaintenanceBulletinsByBulletinIdAttachmentsMutation,
  useGetMaintenanceAttachmentsByAttachmentIdQuery,
  useDeleteMaintenanceAttachmentsByAttachmentIdMutation,
  useGetMaintenanceAlertsQuery,
  usePostMaintenanceByBulletinIdNotificationsResendMutation,
  usePutMaintenanceByBulletinIdPinnedMutation,
  usePostBulletinsByBulletinIdCommentsMutation,
  useGetBulletinsByBulletinIdCommentsQuery,
  usePutBulletinsByBulletinIdCommentsAndCommentIdMutation,
  useDeleteBulletinsByBulletinIdCommentsAndCommentIdMutation,
  usePostMaintenanceBulletinsByBulletinIdAttachmentsboardarchiveMutation,
} = bulletinboardApi
